import { FC, useCallback } from 'react';

import { boundActionsFactory } from 'shared/store/clientSide';
import { useListingLayoutIsShortSelector } from 'shared/store/clientSide/slices/listingLayout';

import { trackToggleMap } from '../internal/tracking';

import { ToggleMapButton } from './ToggleMapButton';

const useBoundActions = boundActionsFactory(reduxActions => ({
  toggleIsShort: reduxActions.listingLayout.toggleIsShort,
}));

export const ToggleMapButtonContainer: FC = () => {
  const isMapOpen = useListingLayoutIsShortSelector();
  const boundActions = useBoundActions();

  const toggleMapOpen = useCallback(() => {
    boundActions.toggleIsShort();
    trackToggleMap(isMapOpen);
  }, [boundActions, isMapOpen]);

  return <ToggleMapButton isMapOpen={isMapOpen} toggleMapOpen={toggleMapOpen} />;
};
